import { useToasts } from "../shared/stores/toasts";
import { I } from "../shared/Icon";

export function Toasts() {
  const items = useToasts((s) => s.items);
  const remove = useToasts((s) => s.remove);

  return (
    <div className="t-toasts">
      {items.map((t) => (
        <div key={t.id} className={`t-toast ${t.kind}`} onClick={() => remove(t.id)}>
          <div className="ico">
            {t.kind === "success" && <I.Check size={16}/>}
            {t.kind === "error" && <I.AlertC size={16}/>}
            {t.kind === "warn" && <I.AlertC size={16}/>}
            {t.kind === "info" && <I.Bell size={16}/>}
          </div>
          <div>
            <div className="title">{t.title}</div>
            {t.desc && <div className="desc">{t.desc}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
